module.exports = __webpack_public_path__ + "static/media/medicalinfo.8d8302ce.svg";